import React from "react";
import styled from "styled-components";
import ContainerBackgroundWrapper from "../components/Backgrounds";
import LogoCenter from "../components/LogoCenter";
import { Tab, Tabs } from "../components/Tabs";
import SorteoListTab from "../components/SorteoListTab";
import TorneoListTab from "../components/TorneoListTab";
import ProgressiveListTab from "../components/ProgressiveListTab";

export const ContenedorSorteo = styled.div`
  width: 100%;
  margin-bottom: 24px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.itemBackground};
  box-shadow: ${(props) => props.theme.shadowBorderColor} 0px 0px 5px 5px;
  background: ${(props) => props.theme.itemBackground} !important;
`;
export const BackgroundListRaffle = styled.div`
  padding: 1rem;
  overflow-y: auto;
  height: calc(100vh - 330px);
`;

const SorteoList = () => {

  return (
    <ContainerBackgroundWrapper>
      <LogoCenter mainview={false} />
      <Tabs>
        <Tab title="Sorteos">
          <SorteoListTab />
        </Tab>
        <Tab title="Torneos">
          <TorneoListTab />
        </Tab>
        <Tab title="Misteriosos">
          <ProgressiveListTab />
        </Tab>
      </Tabs>
    </ContainerBackgroundWrapper>
  );
};

export default SorteoList;
